<div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    <!--FECHA DE REGISTRO-->
    <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
        <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                <div class="category" fxFlex>
                    {{'SHEDULE.TITLE1' | translate}}
                </div>
            </div>
            <!--------- PICK DATE ------->
            <mat-form-field appearance="outline" fxFlex="100" class="pr-4" style="margin-top: 15px; margin-left: 7px; margin-right: 7px;">
                <mat-label>{{'SHEDULE.FECHA' | translate}}</mat-label>
                <input matInput required disabled value="{{ labelDate }}">
                <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
            </mat-form-field>
            <!------- boton  --------->
            <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                <button mat-raised-button color="accent" (click)="addDate(1)" [disabled]="pasoCompleto">{{'SHEDULE.EDITAR' | translate}}</button>
            </div>
        </div>
    </div>

    <!--RECORDATORIOS-->
    <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
        <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                <div class="category" fxFlex>
                    {{'SHEDULE.TITLE2' | translate}}
                </div>
            </div>
            <!--------- PICK DATE ------->
            <mat-form-field appearance="outline" fxFlex="100" class="pr-4" style="margin-top: 15px; margin-left: 7px; margin-right: 7px;">
                <mat-label>{{'SHEDULE.FECHA' | translate}}</mat-label>
                <input matInput required disabled value="{{ labelRecordatorio }}">
                <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
                <mat-error></mat-error>
            </mat-form-field>
            <!------- boton  --------->
            <div class="footer" fxLayout="row" fxLayoutAlign="center center">
                <button mat-raised-button color="accent" (click)="getFechaLanzamiento(); addDate(3);" [disabled]="statusRecordatorios || pasoCompleto">{{'SHEDULE.AGREGAR' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<!---------
<div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="80" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
        <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                <div class="category" fxFlex>
                    {{'SHEDULE.RECORDATORIOS' | translate}}
                </div>
            </div>
            <!--------- PICK DATE ------->
<!---------
            <mat-list>

                <mat-list-item *ngFor="let recordatorio of arrayRecordatorios_second;  let i = index">
                    <mat-icon mat-list-icon>calendar_today</mat-icon>
                    <h4 mat-line>{{'SHEDULE.RECORDATORIO' | translate}}: {{i+1}}</h4>
                    <p mat-line> {{recordatorio |date:"fullDate":'':idiomaActual}} </p>

                </mat-list-item>
                <mat-divider></mat-divider>
            </mat-list>
            <!------- boton  --------->
<!---------      </div>
    </div>
</div>--------->
<!---------
<div class="example-button-row" fxLayoutAlign="center">
  <div class="message-box success" *ngIf="pasoCompleto">
    {{'SHEDULE.SUCCESS_ENCUESTA' | translate}}
  </div>
</div>--------->

<div class="example-button-row" fxLayoutAlign="center" *ngIf="flagButton == 0 && !pasoCompleto">
    <button mat-raised-button color="primary" (click)="velidateBanderas();">{{'SHEDULE.BTN_CREARENCUESTA' | translate}}</button>
</div>
<br><br>

<!-- <ng-container >
  <div class="example-button-row" fxLayoutAlign="center">
      <button mat-raised-button color="secundary" (click)="velidateBanderasNew();">{{'SHEDULE.BTN_CREARENCUESTA' | translate}}</button>
  </div>
</ng-container> -->
<!-- <ng-container *ngIf="EstatusEncuesta">
  <div class="message-box success encuestaCreada" >
      {{'SHEDULE.SUCCESS_ENCUESTA' | translate}}
  </div>
</ng-container> -->

<br><br>

<div class="courses" fxLayout="row" fxLayoutAlign="center" *ngIf="flagButton == 1">
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{'SHEDULE.ENCUESTA' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                    ...
                </mat-panel-description>
            </mat-expansion-panel-header>
            <!------- CREANDO ENCUESTA  --------->
            <div>
                <div *ngIf="flagEncuesta == 1">
                    <code style="center">{{'SHEDULE.CREANDO_ENCUESTA' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagEncuesta == 2">
                    {{'SHEDULE.SUCCESS_ENCUESTA' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagEncuesta == 3">
                    {{'SHEDULE.ERROR_ENCUESTA' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
            </div>
            <br>
            <!------- AGREGANDO USUARIOS  --------->
            <div>
                <div *ngIf="flagUsuarios == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_USUARIOS' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagUsuarios == 2">
                    {{'SHEDULE.SUCCESS_USUARIOS' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagUsuarios == 3">
                    {{'SHEDULE.ERROR_USUARIOS' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
                <br>
            </div>

            <!------- AGREGANDO SECCION1  --------->
            <div>
                <div *ngIf="flagSeccion1 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION1' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion1 == 2 && flagShowSeccion1">
                    {{'SHEDULE.SUCCESS_SECCION1' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion1 == 3 && flagShowSeccion1">
                    {{'SHEDULE.ERROR_SECCION1' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
                <br>
            </div>

            <!------- AGREGANDO SECCION2  --------->
            <div>
                <div *ngIf="flagSeccion2 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION2' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion2 == 2 && flagShowSeccion2">
                    {{'SHEDULE.SUCCESS_SECCION2' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion2 == 3 && flagShowSeccion2">
                    {{'SHEDULE.ERROR_SECCION2' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
            </div>
            <br>
            <!------- AGREGANDO SECCION3  --------->
            <div>
                <div *ngIf="flagSeccion3 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION3' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion3 == 2 && flagShowSeccion3">
                    {{'SHEDULE.SUCCESS_SECCION3' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion3 == 3 && flagShowSeccion3">
                    {{'SHEDULE.ERROR_SECCION3' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
            </div>
            <br>
            <!------- AGREGANDO SECCION4  --------->
            <div>
                <div *ngIf="flagSeccion4 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION4' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion4 == 2 && flagShowSeccion4">
                    {{'SHEDULE.SUCCESS_SECCION4' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion4 == 3 && flagShowSeccion4">
                    {{'SHEDULE.ERROR_SECCION4' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
            </div>
            <br>
            <!------- AGREGANDO SECCION5  --------->
            <div>
                <div *ngIf="flagSeccion5 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION5' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion5 == 2 && flagShowSeccion5">
                    {{'SHEDULE.SUCCESS_SECCION5' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion5 == 3 && flagShowSeccion5">
                    {{'SHEDULE.ERROR_SECCION5' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
            </div>
            <br>
            <!------- AGREGANDO SECCION6  --------->
            <div>
                <div *ngIf="flagSeccion6 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION6' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion6 == 2 && flagShowSeccion6">
                    {{'SHEDULE.SUCCESS_SECCION6' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion6 == 3 && flagShowSeccion6">
                    {{'SHEDULE.ERROR_SECCION6' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
            </div>
            <br>
            <!------- AGREGANDO SECCION7  --------->
            <div>
                <div *ngIf="flagSeccion7 == 1">
                    <code style="center">{{'SHEDULE.AGREGANDO_SECCION7' | translate}}</code>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                <div class="message-box success" *ngIf="flagSeccion7 == 2 && flagShowSeccion7">
                    {{'SHEDULE.SUCCESS_SECCION7' | translate}}
                </div>
                <div class="message-box error" *ngIf="flagSeccion7 == 3 && flagShowSeccion7">
                    {{'SHEDULE.ERROR_SECCION7' | translate}}
                    <button mat-raised-button color="primary" (click)="createEncuesta();">{{'SHEDULE.REINTENTAR' | translate}}</button>
                </div>
                <br>
            </div>
            <br>
        </mat-expansion-panel>

    </mat-accordion>
</div>
<br><br>
<div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
    <ng-container>
        <div>
            <mat-icon aria-hidden="false" class="mr-20" matTooltip="" style="display:none">menu</mat-icon>
            <mat-expansion-panel class="mb-20">
                <mat-expansion-panel-header class="accent-100">
                    <mat-panel-title>
                        {{'SHEDULE.RECORDATORIOS' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <!--------- PICK DATE ------->
                <mat-list>
                    <mat-list-item *ngFor="let recordatorio of arrayRecordatorios_second;  let i = index">
                        <mat-icon mat-list-icon>calendar_today</mat-icon>
                        <h4 mat-line>{{'SHEDULE.RECORDATORIO' | translate}}: {{i+1}}</h4>
                        <p mat-line> {{recordatorio |date:"fullDate":'':idiomaActual}} </p>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-list>
                <!------- boton  --------->
            </mat-expansion-panel>
        </div>
    </ng-container>
</div>

<div style="margin: 20px;">
    <!--<div *ngIf="showButtonInstitute" class="h4 secondary-text" fxLayoutAlign="center center"><code>{{'SHEDULE.TITLE3' | translate}}</code></div>
        <div class="px-16 pb-4" fxLayoutAlign="center center"  *ngIf="showButtonInstitute">
            <div class="pb-8" fxLayout="row" fxLayoutAlign="center center">
                 <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'SHEDULE.FECHA' | translate}}</mat-label>
                            <input matInput required disabled value="{{ labelCierre }}">
                            <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
                        </mat-form-field>
                       <div appearance="outline" fxFlex="100" class="pl-4" *ngIf="showCierre">
                            <button mat-raised-button color="accent" (click)="addDate(2)">{{'SHEDULE.EDITAR' | translate}}</button>
                        </div>
                    </div>
            </div>
        </div>-->



    <!-----------boton finalizar paso---------->
    <!-- <div fxLayout="column" fxLayoutAlign="space-around stretch" class="finishBt" >
          <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-raised-button class="boton undone" fxLayout="row" fxLayoutAlign="center center"  >
            {{'SHEDULE.COMPLETAR_PASO' | translate}}
            <mat-icon>check_box_outline_blank</mat-icon>
          </button>
          <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="boton done" fxLayout="row" fxLayoutAlign="center center"  >
            {{'SHEDULE.PASO_COMPLETADO' | translate}}
            <mat-icon>check_box</mat-icon>
          </button>
        </div> -->

    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'SHEDULE.COMPLETAR_PASO' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
            <mat-icon>done</mat-icon>
          </button>
        <button *ngIf="pasoCompleto" (click)="completarPaso()" mat-raised-button class="done mr-20">
            {{'SHEDULE.PASO_COMPLETADO' | translate}}
            <mat-icon class="ml-20">done</mat-icon>
          </button>
    </div>

</div>
